<template>
  <div class="enrolling-last-verify" v-loading="loading">
    <div v-if="loaded" class="container">
      <div class="content">
        <div class="top">
          <div class="blue-title">报名表信息</div>
        </div>
        <div class="table">
          <div class="table-title">
            <div>陕西工商管理硕士学院</div>
            <div>{{ admissionYear }}年工商管理硕士（MBA）研究生考生报名登记表</div>
          </div>
          <el-form ref="form" :model="enrollBasicInfo">
            <div class="form-up">
              <el-descriptions class="margin-top" :column="5" border :labelStyle="labelStyle" :contentStyle="contentStyle">
                <el-descriptions-item label="姓名" :span="1">
                  <div class="descriptions-content name">
                    <span>{{ basicInfo.trueName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="性别" :span="1.5">
                  <div class="descriptions-content gender">
                    <span>{{ basicInfo.genderName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="出生日期" :span="1.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.birthday.slice(0, 4) }} <span class="common">年</span> {{ basicInfo.birthday.slice(5, 7) }} <span class="common">月</span> {{ basicInfo.birthday.slice(8, 10) }} <span class="common">日</span></span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="籍贯" :span="2">
                  <div class="descriptions-content">
                <span>
                  <span>{{ basicInfo.originProvinceName + basicInfo.originCityName }}</span>
                </span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="民族" :span="2">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.folkName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="所在地市" :span="2">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.regionProvinceName + basicInfo.regionCityName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="政治面貌" :span="2">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.polityName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="证件类型" labelClassName="higher">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.cardTypeName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="证件号码" :span="1.5">
                  <div class="descriptions-content">{{ basicInfo.cardNo }}</div>
                </el-descriptions-item>
                <el-descriptions-item label="参加工作时间" :span="1.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.joinWorkDate.slice(0, 4) }} <span class="common">年</span> {{ basicInfo.joinWorkDate.slice(5, 7) }} <span class="common">月</span></span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="工作单位" :span="2.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.workUnit }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="单位性质" :span="1.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.workUnitTypeName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="职级" labelClassName="higher" :span="2">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.jobLevelName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="所属行业" :span="2">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.industryName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="职务" labelClassName="higher" :span="2.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.jobDuty }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="职称" :span="2.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.jobTitleName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="手机" :span="2.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.mobilePhone }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="电子信箱" :span="2.5">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.email }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="通信地址" :span="2">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.addressRegionName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="详细通信地址" :span="3">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.address }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="最终学历">
                  <div class="descriptions-content">
                    <span>{{ basicInfo.degreeName }}</span>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="none" contentClassName="none-content" :span="4">
                  <div class="descriptions-content">
                    <div class="graduation">
                     <span class="graduation-date">
                       <span class="year">{{ (basicInfo.graduateDate).slice(0, 4) }}</span><span class="grey">年</span>
                       <span class="month">{{ (basicInfo.graduateDate).slice(5, 7) }}</span><span class="grey">月毕业于</span>
                     </span>
                        <span class="school">
                       <span>{{ basicInfo.graduateSchool }}</span>
                     </span>
                        <span class="grey">学校</span>
                        <span class="speciality">
                       <span>{{ basicInfo.graduateMajor }}</span>
                     </span>
                      <span class="grey">专业</span>
                    </div>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="报考教学点" :span="2.5">
                  <div class="descriptions-content text-left">
                    <span>{{ basicInfo.siteName }}</span>
                  </div>
                </el-descriptions-item>
              </el-descriptions>
              <div class="right-img">
                <img v-if="basicInfo.userPhotoPath" :src="basicInfo.userPhotoPath" alt="">
                <span v-else>2寸红底正面免冠照片</span>
              </div>
            </div>
            <div class="form-down">
              <div class="down-left">学习与工作经历</div>
              <el-table
                  :data="basicInfo.experienceList"
                  border
                  :cell-style="{borderColor:'#000'}"
                  :header-cell-style="{borderColor:'#000'}"
                  style="width: 100%">
                  <el-table-column
                    prop="date"
                    label="开始日期"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div>{{ dateToChinese(scope.row.startDate) }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="date"
                    label="结束日期"
                    width="208"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div >{{ dateToChinese(scope.row.endDate) }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="workUnit"
                    label="学习经历或工作单位"
                    width="300"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div>{{ scope.row.workUnit }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="workDuty"
                    label="担任职务" width="195"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div>{{ scope.row.workDuty }}</div>
                      </div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </el-form>
        </div>
        <div class="apply">
          <div class="blue-title apply-title">
            <el-tooltip content="免笔试申请单独审核" placement="top-start"><span>免入学笔试申请</span></el-tooltip>
            <div v-if="basicInfo.exemptWriteType !== '0'">
              <el-tag type="success" v-if="basicInfo.exemptWriteFirstStatus === '1'">初审通过</el-tag>
              <el-tag type="danger" v-else-if="basicInfo.exemptWriteFirstStatus == '0'">初审不通过
                <el-tooltip :content="basicInfo.exemptNoPassReason" placement="right"><i class="el-icon-info"></i></el-tooltip>
              </el-tag>
              <el-tag type="info" v-else>初审待审核</el-tag>
            </div>
            <div v-if="basicInfo.exemptWriteType !== '0' && basicInfo.exemptWriteFirstStatus === '1'">
              <el-tag type="success" v-if="basicInfo.exemptWriteLastStatus === '1'">终审通过</el-tag>
              <el-tag type="danger" v-else-if="basicInfo.exemptWriteLastStatus == '0'">终审不通过
                <el-tooltip :content="basicInfo.exemptNoPassReason" placement="right"><i class="el-icon-info"></i></el-tooltip>
              </el-tag>
              <el-tag type="info" v-else>终审待审核</el-tag>
            </div>
            <div v-if="basicInfo.exemptWriteType !== '0' && basicInfo.exemptWriteLastStatus === '1'">
              <el-tag type="success" v-if="basicInfo.exemptWriteQualityStatus === '1'">资格审查通过</el-tag>
              <el-tag type="danger" v-else-if="basicInfo.exemptWriteQualityStatus == '0'">资格审查不通过
                <el-tooltip :content="basicInfo.exemptNoPassReason" placement="right"><i class="el-icon-info"></i></el-tooltip>
              </el-tag>
              <el-tag type="info" v-else>资格审查待审核</el-tag>
            </div>
          </div>
          <div class="apply-content">
            <div class="apply-reason">
              <div>{{basicInfo.exemptWriteTypeName}}</div>
            </div>
            <div v-if="basicInfo.exemptWriteType !== '0'" class="exempt-file">
              <multi-upload v-model="exemptWriteImageList" :title="exemptWriteFilePathTitle" :limit="-1" :disabled="true"></multi-upload>
              <multi-upload v-model="exemptWrite1ImageList" :title="exemptWriteFileOnePathTitle" :limit="-1" :disabled="true" v-if="basicInfo.exemptWriteType !== '4'"></multi-upload>
              <multi-upload v-model="exemptWrite2ImageList" :title="exemptWriteFileTwoPathTitle" :limit="-1" :disabled="true" v-if="basicInfo.exemptWriteType === '1'" upload-type="pdf"></multi-upload>
            </div>
          </div>
          <div v-if="basicInfo.exemptWriteType !== '0' && basicInfo.exemptWriteFirstStatus === '1' && !basicInfo.exemptWriteQualityStatus" class="exempt-write-verify">
            <div class="verify-item">
              <div class="verify-title">免笔试初审结果：</div>
              <div class="verify-input">
                <el-radio-group v-model="basicInfo.exemptWriteLastStatus" :disabled="!isCanVerify">
                  <el-radio label="1">通过</el-radio>
                  <el-radio label="0">不通过</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div v-if="basicInfo.exemptWriteLastStatus === '0'" class="verify-item">
              <div class="verify-title">审核不通过原因：</div>
              <div class="verify-input">
                <el-input type="textarea" :maxlength="200" :disabled="!isCanVerify"
                          v-model="basicInfo.exemptNoPassReason" placeholder="请输入200字符以内审核不通过原因"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="upload">
          <div class="blue-title">上传材料</div>
          <div class="upload-content">
            <multi-upload v-model="basicInfo.cardPhotoPaths" title="身份证正反面" tips="(顺序：肖像面，国徽面)" :limit="2" :disabled="true"></multi-upload>
            <multi-upload v-model="basicInfo.degreePhotoPaths" title="学历证书" :limit="-1" :disabled="true"></multi-upload>
            <single-upload v-model="basicInfo.userPhotoPath" title="个人照片" :disabled="true"></single-upload>
          </div>
        </div>
      </div>
      <div class="verify-container">
        <div class="verify-item">
          <div class="verify-title">审核结果：</div>
          <div class="verify-input">
            <el-radio-group v-model="basicInfo.verifyLastStatus" :disabled="!isCanVerify">
              <el-radio label="1">通过</el-radio>
              <el-radio label="0">不通过</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="basicInfo.verifyLastStatus === '0'" class="verify-item">
          <div class="verify-title">审核失败原因：</div>
          <div class="verify-input">
            <el-input type="textarea" :maxlength="200" :disabled="!isCanVerify"
                      v-model="basicInfo.verifyNotPassReason" placeholder="请输入200字符以内审核失败原因"></el-input>
          </div>
        </div>
        <div v-if="isCanVerify" class="verify-btn">
          <el-button type="primary" @click="submitVerify">提交审核</el-button>
          <el-button @click="closeWin">关闭窗口</el-button>
        </div>
      </div>
    </div>
    <Hint v-else>
      <span>{{errorMsg}}</span>
    </Hint>
  </div>
</template>

<script>
import Hint from '../../../../../elements/Hint'
import multiUpload from './multiUpload'
import singleUpload from './singleUpload'

export default {
  name: 'EnrollingLastVerify',
  components: {Hint, multiUpload, singleUpload},
  props: {
    cellValue: String,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      loaded: false,
      errorMsg: null,
      isCanVerify: true,
      labelStyle: {
        textAlign: 'center',
        backgroundColor: '#fff',
        border: '1px solid #111111',
        color: '#3E4D41',
        fontSize: '13px'
      },
      contentStyle: {
        textAlign: 'center',
        backgroundColor: '#fff',
        border: '1px solid #111111',
        color: '#3E4D41',
        fontSize: '12px'
      },
      enrollBasicInfo: {},
      basicInfo: {},
      admissionYear: '',
      exemptWriteImageList: [],
      exemptWrite1ImageList: [],
      exemptWrite2ImageList: []
    }
  },
  computed: {
    exemptWriteFilePathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '副高证书照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '2') {
        return '硕士毕业证书信息页照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '3') {
        return '国考准考证照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '4') {
        return '立功受奖证书信息页或专业技术职务资格证书照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileOnePathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '最后学历照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '2') {
        return '硕士学位证书信息页照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '3') {
        return '国考成绩照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileTwoPathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '单位证明'
      } else {
        return '免考材料'
      }
    }
  },
  methods: {
    dateToChinese (dateString) {
      // 将起始日期转换为中文，日期格式为：2020-01-01
      if (!dateString) {
        return ''
      } else if (dateString === '至今') {
        return dateString
      } else {
        dateString = dateString.replace(/-/g, '')
        return dateString.substring(0, 4) + '年' + dateString.substring(4, 6) + '月'
      }
    },
    loadStudentInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/enrollPass/queryStudentLastVerifyInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.cellValue
        })
      }).then(response => {
        if (response && response['data'] && response['data'].errorCode === 0) {
          this.basicInfo = response['data']['enrollBasicInfo']
          this.admissionYear = response['data']['admissionYear']
          this.isCanVerify = response['data']['isCanVerify']
          if (this.basicInfo.exemptWriteFilePath && this.basicInfo.exemptWriteFilePath.length > 0) {
            this.exemptWriteImageList = this.basicInfo.exemptWriteFilePath.split(',')
          }
          if (this.basicInfo.exemptWriteFilePath1 && this.basicInfo.exemptWriteFilePath1.length > 0) {
            this.exemptWrite1ImageList = this.basicInfo.exemptWriteFilePath1.split(',')
          }
          if (this.basicInfo.exemptWriteFilePath2 && this.basicInfo.exemptWriteFilePath2.length > 0) {
            this.exemptWrite2ImageList = this.basicInfo.exemptWriteFilePath2.split(',')
          }
          this.loaded = true
        } else {
          this.errorMsg = response['data']['message'] || '获取学生信息失败'
        }
      }).catch(() => {
        this.errorMsg = '获取学生信息失败'
      }).finally(() => {
        this.loading = false
      })
    },
    submitVerify () {
      if (!this.basicInfo.verifyLastStatus) {
        this.$message.error('请选择审核结果')
        return
      }
      if (this.basicInfo.verifyLastStatus === '0' && !this.basicInfo.verifyNotPassReason) {
        this.$message.error('请输入失败原因')
        return
      }
      if (this.basicInfo.exemptWriteType !== '0' && this.basicInfo.exemptWriteFirstStatus === '1' && !this.basicInfo.exemptWriteQualityStatus) {
        if (!this.basicInfo.exemptWriteLastStatus) {
          this.$message.error('请选择免笔试审核结果')
          return
        }
        if (this.basicInfo.exemptWriteLastStatus === '0' && !this.basicInfo.exemptNoPassReason) {
          this.$message.error('请输入免笔试不通过原因')
          return
        }
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/enrollPass/updateVerifyLastStatus',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.cellValue,
          verifyStatus: this.basicInfo.verifyLastStatus,
          notPassReason: this.basicInfo.verifyNotPassReason,
          exemptVerifyStatus: this.basicInfo.exemptWriteLastStatus,
          exemptNotPassReason: this.basicInfo.exemptNoPassReason
        })
      }).then((res) => {
        if (res && res.data && res.data.errorCode === 0) {
          this.$message.success('提交成功')
          this.closeWin()
        } else {
          let msg = res && res.data && res.data.message ? res.data.message : '提交审核结果失败'
          this.$message.error(msg)
        }
      }).catch(() => {
        this.$message.error('提交审核结果失败')
      }).finally(() => {
        this.loading = false
      })
    },
    closeWin () {
      this.$emit('hidePopoverAndRefresh')
    }
  },
  mounted () {
    this.loadStudentInfo()
  },
  watch: {
    visible: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.loadStudentInfo()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.enrolling-last-verify {
  min-height: 300px;
  & > .container {
    .blue-title {
      color: #0D59A7;
      position: relative;
      font-weight: 550;
      padding-left: 10px;
      font-size: 13px;

      &::before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 20px;
        background-color: #02A7F0;
        margin-right: 10px;
        position: absolute;
        left: 2px;
      }
    }
    & > .content {
      height: 422px;
      overflow: auto;
      padding: 15px 30px;
      position: relative;

      & > .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
      }

      & > .table {
        & > .table-title {
          font-size: 24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
        }

        .el-form {
          .form-up {
            position: relative;
            & > .right-img {
              position: absolute;
              width: 172px;
              height: 220px;
              border: 1px solid #000;
              border-left: none;
              //border-right: none;
              border-bottom: none;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              top: 0;
              right: 0;

              & > img {
                width: 90%;
                height: 90%;
                object-fit: contain;
              }
            }

            .el-descriptions {
              flex: 1;
              letter-spacing: 0.1em;
            }

            ::v-deep  .higher {
              height: 60px !important;
            }

            .descriptions-content {
              text-align: center;
              color: #2213FF;
              font-weight: 550;

              .common {
                color: #3E4D41;
                font-weight: 500;
              }

              & > .graduation {
                color: #3E4D41;
                font-weight: 500;

                & > span {
                  color: #2213FF;
                  font-weight: 550;
                  display: inline-block;
                }

                & > .graduation-date {
                  width: 130px;
                  text-align: left;
                }

                .grey {
                  color: #3E4D41;
                  font-weight: 500;
                }

                & > .school {
                  width: 140px;
                  margin-right: 7px;
                }

                & > .speciality {
                  width: 130px;
                }
              }
            }
            .name {
              max-width: 160px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .text-left {
              text-align: left !important;
            }

            .el-descriptions-item__cell {
              &.empty {
                width: 116.55px;
                border: none !important;
              }

              &.empty-content {
                width: 55px;
                border: none !important;
              }

              &.none {
                border-right: none !important;
              }

              &.none-content {
                border-left: none !important;
              }
            }
          }

          .form-down {
            display: flex;

            .el-date-editor.el-input, .el-date-editor.el-input__inner {
              width: 268px !important;
            }

            & > .down-left {
              font-size: 13px;
              padding: 5px 0;
              width: 68px;
              writing-mode: vertical-rl;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid #3E4D41;
              border-top: 1px solid #fff;
            }

            & > .el-table {
              border-bottom: 1px solid black;
              border-right: 1px solid black;
              margin: 0 auto;

              ::v-deep  thead {
                font-size: 13px;
              }

              .table-center {
                font-size: 12px;
                font-weight: 550;
                color: #2213FF;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: auto;

                .job-and-work-data-adjust {
                  .el-date-editor.el-input, .el-date-editor.el-input__inner {
                    width: 129px !important;
                  }
                }
              }
            }
          }

          & > .add-btn {
            margin-top: 18px;
            display: flex;
            justify-content: center;
          }
        }
      }

      & > .apply {
        margin-top: 30px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 10px;

        & > .apply-title {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        & > .apply-content {
          padding-left: 30px;

          & > .apply-reason {
            padding: 5px;
          }

          & > .exempt-write-verify {
            & > .exempt-write-verify-result {
              display: flex;
              align-items: center;
              gap: 30px;

              & > .title {
                color: #0D59A7;
                font-weight: 550;
              }

              & > .result {
                display: flex;
              }
            }

            & > .exempt-write-verify-button {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        & > .exempt-write-verify {
          padding: 10px;
          background-color: #EBEEF5;
          & > .verify-item {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 10px;
            & > .verify-input {
              width: 300px;
            }
          }
        }
      }

      & > .upload {
        margin-top: 40px;

        & > .blue-title {
          margin-bottom: 15px;
        }

        & > .upload-content {
        }
      }
    }
    & > .verify-container {
      padding: 10px;
      & > .verify-item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 10px;
        & > .verify-input {
          width: 300px;
        }
      }
      & > .verify-btn {
        text-align: center;
      }
    }
  }
}
</style>
